export default {
      id: "fortement-nuageux-usage",
      viewBox: "0 0 91 91",
      url: "../dist/images/" + "sprite.svg#fortement-nuageux-usage",
      toString: function () {
        return this.url;
      }
    }